/* Surprise Your Love — global.js (header, drawer, reveal, sticky bar, gallery, video, deep links) */
(function () {
  'use strict';
  var d = document;

  /* Header shadow on scroll */
  var header = d.querySelector('.site-header');
  function onScroll() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 20);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Mobile drawer */
  d.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    var close = e.target.closest('[data-drawer-close]');
    var drawer = d.querySelector('[data-drawer]');
    if (!drawer) return;
    if (open) { drawer.classList.add('is-open'); d.body.style.overflow = 'hidden'; }
    if (close || (e.target.closest('[data-drawer] a') && drawer.classList.contains('is-open'))) {
      drawer.classList.remove('is-open'); d.body.style.overflow = '';
    }
  });

  /* "Book Now" links: scroll to #book if present, otherwise go to home page booking */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"], a[data-book-link]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var target = d.getElementById(href.slice(1));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (a.hasAttribute('data-book-link') || href === '#book') {
      e.preventDefault();
      var syl = window.SYL || {};
      if (syl.bookUrl) window.location.href = syl.bookUrl + (syl.jumpToForm ? '#book' : '');
      else window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + href;
    }
  });

  /* Deep-link selections into the booking form (occasion cards, pricing plans, add-on cards) */
  d.addEventListener('click', function (e) {
    var el = e.target.closest('[data-select-occasion],[data-select-variant],[data-addon-toggle]');
    if (!el) return;
    var detail = {};
    if (el.hasAttribute('data-select-occasion')) detail.occasion = el.getAttribute('data-select-occasion');
    if (el.hasAttribute('data-select-variant')) detail.variant = el.getAttribute('data-select-variant');
    if (el.hasAttribute('data-addon-toggle')) {
      detail.addon = el.getAttribute('data-addon-toggle');
      detail.addonPrice = el.getAttribute('data-addon-price');
      detail.addonTitle = el.getAttribute('data-addon-title');
      var added = !el.classList.contains('is-added');
      detail.addonOn = added;
      el.classList.toggle('is-added', added);
      var label = el.querySelector('[data-label]');
      if (label) label.textContent = added ? (el.getAttribute('data-added-text') || 'Added ✓') : (el.getAttribute('data-add-text') || 'Add to booking');
    }
    d.dispatchEvent(new CustomEvent('syl:select', { detail: detail }));
    if (!detail.addon) {
      var href = el.getAttribute('href') || '#book';
      var book = d.getElementById('book');
      /* Only stay on the page when the button points at an on-page anchor; product links navigate normally */
      if (href.charAt(0) === '#' && book) { e.preventDefault(); book.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  /* Reveal on scroll */
  var reveals = d.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && d.body.classList.contains('has-anim')) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Sticky mobile booking bar: visible after the hero, hidden while booking form is on screen */
  var bar = d.querySelector('[data-sticky-book]');
  if (bar) {
    bar.hidden = false;
    var bookVisible = false;
    var book = d.getElementById('book');
    if (book && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bookVisible = en[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(book);
    }
    function update() {
      bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.6 && !bookVisible);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* Lightbox for gallery */
  var items = [];
  var idx = 0;
  var lb;
  function renderLb() {
    var it = items[idx];
    var stage = lb.querySelector('.lightbox__stage');
    stage.innerHTML = '';
    if (it.type === 'video') {
      var v = d.createElement('video');
      v.src = it.src; v.controls = true; v.autoplay = true; v.playsInline = true;
      stage.appendChild(v);
    } else if (it.type === 'embed') {
      var f = d.createElement('iframe');
      f.src = it.src; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
      stage.appendChild(f);
    } else {
      var img = d.createElement('img');
      img.src = it.src; img.alt = it.alt || '';
      stage.appendChild(img);
    }
  }
  function openLb(group, i) {
    items = Array.prototype.map.call(d.querySelectorAll('[data-lb="' + group + '"]'), function (el) {
      return { type: el.getAttribute('data-lb-type') || 'image', src: el.getAttribute('data-lb-src'), alt: el.getAttribute('aria-label') };
    });
    idx = i;
    if (!lb) {
      lb = d.createElement('div');
      lb.className = 'lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<button class="lightbox__close" aria-label="Close"><svg class="icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '<button class="lightbox__nav lightbox__nav--prev" aria-label="Previous"><svg class="icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>' +
        '<div class="lightbox__stage"></div>' +
        '<button class="lightbox__nav lightbox__nav--next" aria-label="Next"><svg class="icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>';
      d.body.appendChild(lb);
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.closest('.lightbox__close')) closeLb();
        else if (e.target.closest('.lightbox__nav--prev')) { idx = (idx - 1 + items.length) % items.length; renderLb(); }
        else if (e.target.closest('.lightbox__nav--next')) { idx = (idx + 1) % items.length; renderLb(); }
      });
      d.addEventListener('keydown', function (e) {
        if (!lb || lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowRight') { idx = (idx + 1) % items.length; renderLb(); }
        if (e.key === 'ArrowLeft') { idx = (idx - 1 + items.length) % items.length; renderLb(); }
      });
    }
    lb.hidden = false;
    var multi = items.length > 1;
    lb.querySelectorAll('.lightbox__nav').forEach(function (b) { b.hidden = !multi; });
    d.body.style.overflow = 'hidden';
    renderLb();
  }
  function closeLb() { lb.hidden = true; lb.querySelector('.lightbox__stage').innerHTML = ''; d.body.style.overflow = ''; }
  d.addEventListener('click', function (e) {
    var el = e.target.closest('[data-lb]');
    if (!el) return;
    e.preventDefault();
    var group = el.getAttribute('data-lb');
    var all = Array.prototype.slice.call(d.querySelectorAll('[data-lb="' + group + '"]'));
    openLb(group, all.indexOf(el));
  });

  /* Click-to-play video features (Shopify video or YouTube/Vimeo) */
  d.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-video-play]');
    if (!btn) return;
    var wrap = btn.closest('.video-feature');
    var tpl = wrap && wrap.querySelector('template');
    if (!tpl) return;
    wrap.appendChild(tpl.content.cloneNode(true));
    btn.remove();
    var poster = wrap.querySelector('.video-feature__poster');
    if (poster) poster.remove();
    var v = wrap.querySelector('video');
    if (v) v.play();
  });

  /* Product page thumbnails */
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pmedia-thumb]');
    if (!t) return;
    var main = d.querySelector('[data-pmedia-main]');
    if (!main) return;
    main.innerHTML = '<img src="' + t.getAttribute('data-src') + '" alt="">';
    d.querySelectorAll('[data-pmedia-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === t); });
  });
})();
